/**
 * DTO întors de GET /dashboard/upcoming-containers.
 * Coloanele UI sunt fixate: Container (no + type), Firmă, Rută POL→POD, ETA,
 * Progres 0..1, Status (id din claudeMockData.CONTAINER_STATUSES).
 */
export interface UpcomingContainerRow {
  id: number;
  containerNumber: string;
  containerType: string;
  bookingNumber: string;
  companyName: string;
  companyId: number;
  /** Shipper de pe primul B/L al containerului (fallback container / booking). */
  shipperName?: string | null;
  pol: string;
  pod: string;
  /** Data On Board (booking.onBoardDate). */
  onBoardDate?: string | null;
  /** ISO string sau null. */
  eta: string | null;
  /** Cod port la care se referă ETA (export). */
  etaPort?: string | null;
  etaPortName?: string | null;
  etaIsFinal?: boolean;
  etaEstimated?: boolean;
  /** Progres 0..1 (timp scurs raportat la durata estimată). */
  progress: number;
  /** in_transit | transshipment | black_sea | discharged | in_delivery | completed */
  status: string;
}

export const EMPTY_UPCOMING_CONTAINERS: UpcomingContainerRow[] = [];
